import {get, post} from "../APIGateWay";

export async function getClasses(params = {}) {
    return await get(params, '/classes')
}